import './LandMainPage.css'
import 'antd/dist/reset.css'
import React from 'react'
import { Row, Col, Button, Space, Divider } from 'antd'
import LandBottomLayout from '../common/LandBottomLayout'
import {
  getMainThemeProducts,
  getSubThemeProducts,
} from '../../products/ProductProvider'

export default class LandMainPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {
    window.scrollTo(0, 0)
  }

  render() {
    return (
      <div className="LandMainPage">
        {this.getMainThemeProductsLayout()}
        {this.getSubThemeProductsLayout()}

        <Divider
          style={{
            marginTop: 0,
            marginBottom: 0,
            borderColor: '#7cb305',
          }}
        />

        <div className="LandCompanyWrapper">
          <div className="LandCompanyInfo">
            <div className="LandCompanyInfoName">{'公司介绍'}</div>
            <div className="LandCompanyInfoIntroduction">
              {
                '江苏凯士达阀门科技有限公司，是国内一家阀门创新型企业，专注于高端仪表管阀件的研发、生产和销售。公司总部位于江苏省，凭借创新的技术、精湛的工艺和卓越的服务，迅速在国内外细分阀门领域中占据了一席之地。江苏凯士达阀门科技有限公司在危化品运输、半导体行业和氢能领域，拥有独特的市场优势和领先的技术水平，致力于为全球客户提供更高效、更安全、更环保的解决方案。'
              }
            </div>
            <div className="LandCompanyInfoIntroduction">
              {
                '公司产品广泛应用于槽罐车、氢能、半导体、化工、精细化工、医药卫生、食品饮料、酿造、石油储存、油品提炼、电力、冶金、水处理、气体处理、矿业等多个领域，涉及的产品包括但不限于高性能阀门、管件、仪表控制设备及系统。我们的产品在确保密封性、安全性和可靠性的基础上，优化了设计，提升了使用寿命，符合国际领先的质量标准。'
              }
            </div>
          </div>
        </div>

        <LandBottomLayout {...this.props} />
      </div>
    )
  }

  getMainThemeProductsLayout = () => {
    const products = getMainThemeProducts()
    return (
      <div>
        {this.getMainThemeProductGrid(products[0], 3)}
        {this.getMainThemeProductGrid(products[1], 2)}
        {this.getMainThemeProductGrid(products[2], 1)}
        {this.getMainThemeProductGrid(products[3], 2)}
        {this.getMainThemeProductGrid(products[4], 1)}
      </div>
    )
  }

  getMainThemeProductGrid = (product, index) => {
    return (
      <div className={`LandMainThemeProductGrid_${index}`}>
        <div className={`LandMainThemeProductGridLeft_${index}`}>
          <div
            className={`LandMainThemeProductGridName_${index}`}
            onClick={(e) => {
              this.viewProductDetail(product.pid)
            }}
          >
            {product.name}
          </div>
          <div
            className={`LandMainThemeProductGridSlogan_${index}`}
            onClick={(e) => {
              this.viewProductDetail(product.pid)
            }}
          >
            {product.feature}
          </div>
          <div className={`LandMainThemeProductGridLink_${index}`}>
            <Space size={'large'}>
              <Button
                type="primary"
                style={{
                  paddingLeft: 50,
                  paddingRight: 50,
                  paddingTop: 18,
                  paddingBottom: 18,
                  fontSize: 16,
                  fontWeight: '400',
                  fontFamily: 'MyCustomizedFont',
                }}
                onClick={() => {
                  this.viewContact()
                }}
              >
                咨询购买
              </Button>
              <Button
                type="default"
                style={{
                  paddingLeft: 50,
                  paddingRight: 50,
                  paddingTop: 18,
                  paddingBottom: 18,
                  fontSize: 16,
                  fontWeight: '400',
                  fontFamily: 'MyCustomizedFont',
                }}
                onClick={() => this.viewProductDetail(product.pid)}
              >
                了解更多
              </Button>
            </Space>
          </div>
        </div>
        <img
          className={`LandMainThemeProductGridRight_${index}`}
          src={product.picture}
          onClick={(e) => {
            this.viewProductDetail(product.pid)
          }}
        />
      </div>
    )
  }

  getSubThemeProductsLayout = () => {
    const products = getSubThemeProducts()
    return (
      <div className="LandProductGridWrapper">
        <Row gutter={[{ xs: 8, sm: 16, md: 24, lg: 32, xl: 40, xxl: 48 }, 20]}>
          {products.map((product) => (
            <Col span={12}>{this.getProductCard(product)}</Col>
          ))}
        </Row>
      </div>
    )
  }

  getProductCard = (product) => {
    return (
      <div
        className="LandProductGrid"
        onClick={() => this.viewProductDetail(product.pid)}
      >
        <img className="LandProductGridImage" src={product.picture} />
        <div className="LandProductGridName">{product.name}</div>
        <div className="LandProductGridLink">
          <Space size={'large'}>
            {product.purchasable
              ? this.getCommonLinkButton(product)
              : this.getCommonConsultButton()}
            <Button
              type="default"
              style={{
                fontSize: 16,
                fontWeight: '400',
                fontFamily: 'MyCustomizedFont',
              }}
              onClick={() => this.viewProductDetail(product.pid)}
            >
              了解更多
            </Button>
          </Space>
        </div>
      </div>
    )
  }

  getCommonLinkButton = (product) => {
    return (
      <Button
        type="primary"
        style={{
          fontSize: 16,
          fontWeight: '400',
          fontFamily: 'MyCustomizedFont',
        }}
        onClick={() => {
          this.gotoShop(product)
        }}
      >
        立即购买
      </Button>
    )
  }

  getCommonConsultButton = () => {
    return (
      <Button
        color="pink"
        variant="filled"
        style={{
          fontSize: 16,
          fontWeight: '400',
          fontFamily: 'MyCustomizedFont',
        }}
        onClick={(e) => {
          e.stopPropagation()
          this.viewContact()
        }}
      >
        咨询购买
      </Button>
    )
  }

  viewProductDetail = (pid) => {
    this.props.history.push('/product?pid=' + pid)
  }

  viewContact = () => {
    this.props.history.push('/contact')
  }

  gotoShop = (product) => {
    window.open(product.link, '_blank')
  }
}
